import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { icon: 'dashboard', label: 'Overview', path: '/admin/overview' },
  { icon: 'description', label: 'Applications', path: '/admin/applications' },
  { icon: 'work', label: 'Openings', path: '/admin/openings' },
  { icon: 'menu_book', label: 'Course Imports', path: '/admin/courses/import' },
  { icon: 'library_books', label: 'All Courses', path: '/admin/courses' },
  { icon: 'domain', label: 'Institutions', path: '/admin/institutions' },
  { icon: 'group', label: 'Agents', path: '/admin/agents' },
  { icon: 'payments', label: 'Payments', path: '/admin/payments' },
  { icon: 'reviews', label: 'Testimonials', path: '/admin/testimonials' },
  { icon: 'quiz', label: 'FAQ', path: '/admin/faqs' },
  { icon: 'mail', label: 'Newsletter', path: '/admin/newsletter' },
  { icon: 'public', label: 'Country Guides', path: '/admin/country-guides' },
];

export default function AdminSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const close = () => setIsOpen(false);

  return (
    <>
      {/* Mobile top bar */}
      <div className="md:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b border-[#e2e8f0] flex items-center justify-between px-4 z-40">
        <button onClick={() => setIsOpen(true)} className="p-2 text-[#00255a]">
          <span className="material-symbols-outlined">menu</span>
        </button>
        <h1 className="text-lg font-bold text-[#00255a]">IASC Admin</h1>
        <div className="w-10" />
      </div>

      {/* Backdrop */}
      {isOpen && (
        <div onClick={close} className="fixed inset-0 bg-black/40 z-40 md:hidden" />
      )}

      {/* Sidebar / mobile drawer */}
      <aside
        className={`fixed left-0 top-0 h-screen w-64 flex flex-col py-8 bg-white shadow-[0px_10px_30px_rgba(30,60,114,0.05)] border-r border-[#e2e8f0] z-50 transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0`}
      >
        <div className="px-6 mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#00255a]">IASC Admin</h1>
            <p className="text-xs text-[#64748b] mt-1">Consultancy Portal</p>
          </div>
          <button onClick={close} className="md:hidden p-1 text-[#64748b]">
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto space-y-1 px-4 min-h-0">
          {NAV_ITEMS.map((item) => {
            // Pick the most specific (longest) matching path so that, e.g.,
            // /admin/courses/import only highlights "Course Imports" and not
            // also "All Courses" (which is a prefix of it).
            const bestMatch = NAV_ITEMS
              .filter((it) => location.pathname === it.path || location.pathname.startsWith(`${it.path}/`))
              .sort((a, b) => b.path.length - a.path.length)[0];
            const active = item.path === bestMatch?.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={close}
                className={`flex items-center px-4 py-3 rounded-lg font-semibold transition-all text-sm ${
                  active ? 'text-[#00255a] bg-[#e6e8ea] border-r-4 border-[#00255a] scale-[0.98]' : 'text-[#64748b] hover:bg-[#f2f4f6] hover:text-[#00255a]'
                }`}
              >
                <span className="material-symbols-outlined mr-3">{item.icon}</span>
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="flex-shrink-0 px-4 space-y-1 border-t border-[#e2e8f0] pt-4 mt-4">
          <Link
            to="/admin/openings?action=create"
            onClick={close}
            className="w-full block text-center text-white font-semibold py-3 rounded-xl shadow-md hover:scale-[1.02] active:scale-[0.98] transition-transform mb-4"
            style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
          >
            New Opening
          </Link>
          <Link to="/admin/profile" onClick={close} className="flex items-center px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f2f4f6] hover:text-[#00255a] transition-all text-sm">
            <span className="material-symbols-outlined mr-3">account_circle</span>
            <span>My Profile</span>
          </Link>
          <Link to="/admin/settings" onClick={close} className="flex items-center px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f2f4f6] hover:text-[#00255a] transition-all text-sm">
            <span className="material-symbols-outlined mr-3">settings</span>
            <span>Settings</span>
          </Link>
          <button
            onClick={() => { localStorage.removeItem('adminToken'); navigate('/admin/login'); }}
            className="w-full flex items-center px-4 py-3 rounded-lg text-[#64748b] hover:bg-[#f2f4f6] hover:text-[#00255a] transition-all text-sm text-left"
          >
            <span className="material-symbols-outlined mr-3">logout</span>
            <span>Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
}